import { render, staticRenderFns } from "./RegularMedia.vue?vue&type=template&id=182e9bb9&scoped=true&name=regular-media&"
import script from "./RegularMedia.vue?vue&type=script&lang=js&"
export * from "./RegularMedia.vue?vue&type=script&lang=js&"
import style0 from "./RegularMedia.vue?vue&type=style&index=0&id=182e9bb9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "182e9bb9",
  null
  
)

export default component.exports